module.exports = __webpack_public_path__ + "img/boleto.42f074a6.svg";